import React from 'react'
import Popover from '@mui/material/Popover'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import { TColumn } from './tableTypes'

export type TRow = {
  value: TColumn
  list: string[] | React.ReactNode[]
}

export const CellList: React.FC<TRow> = ({ value, list }) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const isPopoverOpen = Boolean(anchorEl)

  return (
    <>
      <div
        onMouseEnter={(event) => setAnchorEl(event.currentTarget)}
        onMouseLeave={() => setAnchorEl(null)}
      >
        {value}
      </div>
      {list.length ? (
        <Popover
          sx={{ pointerEvents: 'none' }}
          disableScrollLock
          open={isPopoverOpen}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          onClose={() => setAnchorEl(null)}
          disableRestoreFocus
        >
          <List>
            {list.map((value, index) => (
              <ListItem
                key={index}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  maxWidth: '200px',
                }}
              >
                <div style={{ width: '100%' }}>{value}</div>
              </ListItem>
            ))}
          </List>
        </Popover>
      ) : (
        ''
      )}
    </>
  )
}

export default CellList
